
export enum formActionType {
    UPDATE_PREVIOUS_PROJECT_NAME = "UPDATE_PREVIOUS_PROJECT_NAME",
}